import { useState, useEffect } from 'react';
import { supabase, isSupabaseConfigured } from '../lib/supabaseClient';
import type { ReviewForSchema } from '../utils/reviewSchema';

export function useApprovedReviews() {
  const [reviews, setReviews] = useState<ReviewForSchema[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchReviews() {
      if (!isSupabaseConfigured()) {
        setLoading(false);
        return;
      }

      try {
        const { data, error } = await supabase
          .from('reviews')
          .select('customer_name, rating, comment, created_at')
          .eq('approved', true)
          .eq('archived', false)
          .order('created_at', { ascending: false });

        if (error) throw error;
        if (!cancelled) setReviews(data || []);
      } catch {
        if (!cancelled) setReviews([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchReviews();
    return () => {
      cancelled = true;
    };
  }, []);

  return { reviews, loading };
}
